import { useMutation } from '@tanstack/react-query';
import type AgentApiAiJobSearchRunsItem from '@/types/serializers/AgentApiAiJobSearchRunsItem';

type CreateRunRequest = {
  job_search_persona_id: number;
};

/** AI求人検索ランを新規作成するミューテーション */
export default function useCreateAiJobSearchRun() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;

  return useMutation({
    mutationFn: async (request: CreateRunRequest): Promise<AgentApiAiJobSearchRunsItem> => {
      const response = await fetch('/agent/api/ai_job_search_runs', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify(request),
      });

      if (!response.ok) {
        const errorBody = await response.json().catch(() => ({}));
        const message =
          typeof errorBody?.message === 'string'
            ? errorBody.message
            : '検索ランの起動に失敗しました';
        throw new Error(message);
      }

      const data: AgentApiAiJobSearchRunsItem = await response.json();
      return data;
    },
  });
}
